import { Card, Chip, Stack, Tooltip } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { FaChevronRight } from "react-icons/fa6";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { calculateDaysAgo, cn } from "src/lib/utils";
import NotificationBellIcon from "../Icon/NotificationBellIcon";
import Notification from '../../Components/Notification/Notification';
import ProfileIcon from "./ProfileIcon";
import Profile from "src/Components/Profile/Profile";
import { useRiskStore } from "src/Containers/Risk/Store/RiskStore";
import { breadcrumbMap, COMPLIANCE_SETUP, INITIATE, manageCompliance, risk, history } from '../../Entities/CommonEntities'
import { RISK, MAIN_CONTAINER, ISSUE, REJECTED } from '../../Entities/RoutePath'
import { useIssueStore } from "src/Containers/IssueRegister/store/IssueStore";
import { chipColorStyle } from "src/Entities/RiskTypes";
import { STATUS_ENUMS } from "src/Entities/StatusEnums";
// Define a mapping of routes to breadcrumb labels
const breadcrumbsMap = {
    "/help-center/dashboard": "Dashboard",
    "/help-center/governance": "Governance",
    "/help-center/risk": "Risk",
    "/help-center/compliance": "Compliance",
    "/help-center/calendar": "Calendar",
    "/help-center/tools": "Tools",
    "/help-center/settings": "Settings"

};

const Breadcrumbs = ({ CallBackHeading }) => {
    const location = useLocation();
    const navigate = useNavigate()
    const { RiskDetailsById } = useRiskStore()
    const { issueDetailsById } = useIssueStore()
    const pathnames = location.pathname.split("/").filter(x => x);
    const lastIndexPath = pathnames?.length - 1
    const [notifications, setNotifications] = useState([])
    const [notificationAnchor, setNotificationAnchor] = useState(null);
    const [ProfileAnchor, setProfileAnchor] = useState(null);
    const [riskDetails, setRiskDetails] = useState(null);
    const [issueDetails, setIssueDetails] = useState(null);
    const [complianceDetails, setComplianceDetails] = useState(null);
    useEffect(() => {
        setComplianceDetails(location?.state?.complianceDetails);
    }, [location?.state?.complianceDetails])
    const currentDate = new Date();
    const somePastDate = typeof riskDetails?.createdAt === 'string' ? new Date(riskDetails?.createdAt) : riskDetails?.createdAt;
    const issuePastDate = typeof issueDetailsById?.issueInformation?.createdAt === 'string' ? new Date(issueDetailsById?.issueInformation?.createdAt) : issueDetailsById?.issueInformation?.createdAt;



    const daysAgo = calculateDaysAgo(currentDate, somePastDate);
    const filteredPathnames = pathnames.slice(1);

    const riskDetailsStatusColor = riskDetails?.riskStatus === 'Deny' ? 'hsl(var(--destructive))' : riskDetails?.riskStatus === 'Rejected' ? 'hsl(var(--card))' : riskDetails?.riskStatus === 'Close' ? 'hsl(var(--Controlled))' : 'hsl(var(--primary))'
    const riskDetailsStatusBgColor = riskDetails?.riskStatus === 'Deny' ? 'hsl(var(--destructive-foreground))' : riskDetails?.riskStatus === 'Rejected' ? 'hsl(var(--Extreme))' : riskDetails?.riskStatus === 'Close' ? 'hsl(var(--Controlled))' : 'hsl(var(--primary-foreground))'
    const issueDetailsStatusColor = issueDetails?.issueStatus === 'Deny' ? 'hsl(var(--destructive))' : issueDetails?.issueStatus === 'Rejected' ? 'hsl(var(--card))' : issueDetails?.issueStatus === 'Close' ? 'hsl(var(--Controlled))' : 'hsl(var(--primary))'
    const issueDetailsStatusBgColor = issueDetails?.issueStatus === 'Deny' ? 'hsl(var(--destructive-foreground))' : issueDetails?.issueStatus === 'Rejected' ? 'hsl(var(--Extreme))' : issueDetails?.issueStatus === 'Close' ? 'hsl(var(--Controlled))' : 'hsl(var(--primary-foreground))'


    useEffect(() => {
        if (location?.state?.riskDetails && RiskDetailsById?.riskInformation) {
            setRiskDetails(RiskDetailsById.riskInformation);
        }
    }, [location?.state?.riskDetails, RiskDetailsById]);
    useEffect(() => {
        const issueData = location?.state?.issueDetails;
        if (issueData && issueDetailsById?.issueInformation) {
            setIssueDetails(issueDetailsById.issueInformation);
        }
    }, [location.state, issueDetailsById?.issueInformation])
    const formatBreadcrumb = (segment) => {
        if (!isNaN(segment)) return `#${segment}`;
        return breadcrumbMap[segment] || decodeURIComponent(segment);
    }

    const handleClickNotification = (event) => {
        setNotificationAnchor(event.currentTarget)
    };

    const handleClickProfile = (event) => {
        setProfileAnchor(event.currentTarget);
    };
    const queryParams = new URLSearchParams(location.search)

    const view = queryParams.get('view')

    const RiskChip = () => {
        if (!riskDetails) return null;

        const chipStyles = {
            ml: 2,
            fontWeight: 600,
            cursor: "pointer",
            color: 'hsl(var(--card))'
        };

        return (
            <div className='flex flex-row justify-betweem w-full items-center not-italic'>
                <div className="w-[80%]">
                    <span className='text-primary text-setting font-semibold'>
                        {riskDetails.title} #{filteredPathnames[filteredPathnames.length - 1]?.replace("R", "")}
                    </span>
                    <Chip
                        label={riskDetails.riskScoreName}
                        sx={{ ...chipStyles, backgroundColor: chipColorStyle(riskDetails.riskScoreName) }}
                    />
                    <span className='ml-2 text-muted text-h4'>
                        {daysAgo || 0}
                    </span>
                    <Chip
                        label={riskDetails.riskStatus}
                        sx={{ ...chipStyles, backgroundColor: riskDetailsStatusBgColor, color: riskDetailsStatusColor }}
                    />
                </div>
                <div className="w-[20%]">
                    <div className="basis-1/6 flex flex-row justify-end items-center gap-5 mr-4">
                        <Tooltip title="Notification" placement="bottom" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <div className='pt-2'>
                                <NotificationBellIcon isNotify={notifications?.some(notification => notification?.isRead === false)} handleClickNotification={handleClickNotification} cursor='pointer' width='30' height='28' />
                            </div>
                        </Tooltip>
                        <Tooltip title="Profile" placement="bottom" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <div>
                                <ProfileIcon handleClickProfile={handleClickProfile} />
                            </div>
                        </Tooltip>
                    </div>
                </div>
            </div>
        );
    };
    const IssueChip = () => {
        const data = issueDetails
        if (!data) return null
        const chipStyles = {
            ml: 2,
            fontWeight: 600,
            cursor: "pointer",
            color: 'hsl(var(--card))'
        };

        return (
            <div className='flex flex-row justify-betweem w-full items-center not-italic'>
                <div className="w-[80%]">
                    <span className='text-primary text-setting font-semibold'>
                        {data?.title} #{filteredPathnames[filteredPathnames.length - 1]?.replace("R", "")}
                    </span>
                    <Chip
                        label={data?.issueScoreName}
                        sx={{ ...chipStyles, backgroundColor: chipColorStyle(data?.issueScoreName) }}
                    />
                    <span className='ml-2 text-muted text-h4'>
                        {calculateDaysAgo(currentDate, issuePastDate) || 0}
                    </span>
                    <Chip
                        label={data?.issueStatus}
                        sx={{ ...chipStyles, backgroundColor: issueDetailsStatusBgColor, color: issueDetailsStatusColor }}
                    />
                </div>
                <div className="w-[20%]">
                    <div className="basis-1/6 flex flex-row justify-end items-center gap-5 mr-4">
                        <Tooltip title="Notification" placement="bottom" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <div className='pt-2'>
                                <NotificationBellIcon isNotify={notifications?.some(notification => notification?.isRead === false)} handleClickNotification={handleClickNotification} cursor='pointer' width='30' height='28' />
                            </div>
                        </Tooltip>
                        <Tooltip title="Profile" placement="bottom" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <div>
                                <ProfileIcon handleClickProfile={handleClickProfile} />
                            </div>
                        </Tooltip>
                    </div>
                </div>
            </div>
        );
    };

    const CallBack = () => {
        if (location.search.includes('complianceId')) {
            return (<div className='px-4 py-4 bg-card border-[1px] border-bottom-[hsl(var(--primary-foreground))]'>
                <div className='text-primary text-xl font-semibold'>
                    {filteredPathnames[filteredPathnames.length - 1].split('%20').join(' ') + ' '}
                    {complianceDetails?.detailReferenceId && complianceDetails?.approvalStatus === STATUS_ENUMS.Closed && <Chip
                        label={complianceDetails?.detailReferenceId}
                        sx={{ backgroundColor: 'hsl(var(--primary))', color: 'hsl(var(--card))', height: '24px' }}
                    />}
                </div>
            </div>)
        }

        if (filteredPathnames[filteredPathnames.length - 2]?.includes('rejected-risk') || filteredPathnames[filteredPathnames.length - 2]?.includes('history') || filteredPathnames[filteredPathnames.length - 2]?.includes('dispute') || filteredPathnames[filteredPathnames.length - 3]?.includes(risk.URI) && filteredPathnames.length === 3 && RiskChip() && location.pathname.includes(risk.URI)) {
            return (<div className='px-4 py-1.5 bg-card border-[1px] border-bottom-[hsl(var(--primary-foreground))]'>
                {RiskChip()}
            </div>)
        }
        if (('/' + filteredPathnames[filteredPathnames.length - 3])?.includes(ISSUE.URI) && filteredPathnames.length === 3 && IssueChip()) {
            return (<div className='px-4 py-1.5 bg-card border-[1px] border-bottom-[hsl(var(--primary-foreground))]'>
                {<IssueChip />}
            </div>)
        }
        return null

    }
    useEffect(() => {
        CallBackHeading(CallBack());
    }, [location.pathname, riskDetails, issueDetails, complianceDetails])

    // Find a matching breadcrumb label where the pathname includes the key
    const matchedPath = Object.keys(breadcrumbsMap).find((key) =>
        location.pathname.includes(key)
    );


    const breadcrumbLabel = location.pathname.includes("/help-center")
        ? matchedPath
            ? breadcrumbsMap[matchedPath]
            : "Help Center"
        : null;
    let manageComplianceParams = ['bodyType', 'matrix', 'status', 'cutoff', 'view']
    return (
        <Fragment>
            <Card className={cn("justify-center border-t-0 h-full border-x-0 border-b-[2px] border-t-[2px] border-l-[1px] border-l-[hsl(var(--primary))] border-b-[hsl(var(--primary-foreground))] border-t-[hsl(var(--primary-foreground))] rounded-none p-1.5")}>
                <div className='flex flex-row h-full'>
                    <div className="basis-5/6">
                        <Stack className="flex flex-row items-center text-subHeading-2 text-muted h-full pl-5" sx={{ display: 'flex', flexDirection: 'row' }}>
                            {breadcrumbLabel ? (
                                <span className="ml-4 text-primary text-2xl font-semibold">
                                    {breadcrumbLabel}
                                </span>
                            ) : pathnames.map((segment, index) => {
                                let routePath = `/${pathnames.slice(0, index + 1).join("/")}`;
                                return (
                                    index !== 0 &&
                                    <div key={routePath} className={cn(index === lastIndexPath ? "text-primary" : 'text-border', 'flex flex-row items-center')}>
                                        <div onClick={() => {
                                            if (segment === risk.URI?.replace('/', '')) {
                                                navigate(MAIN_CONTAINER.MAIN + '/' + risk.URI + '/' + INITIATE, { state: location.state })
                                            } else {
                                                let params = ''
                                                    params = location.search.split('?')[1]
                                                if (pathnames[1] === manageCompliance.URI && pathnames?.length === 3) {
                                                    navigate(`${MAIN_CONTAINER.MAIN}/${manageCompliance.URI}?bodyType=1&matrix=1&status=1&cutoff=1&view=${view}`)
                                                }
                                                if (formatBreadcrumb(segment) === 'Compliance Setup') {
                                                    params = '?' + params.split('&').filter((param) => manageComplianceParams.includes(param.split('=')[0])).join('&')
                                                    routePath = `/${pathnames.slice(0, 2).join("/")}${params}`;
                                                    navigate(routePath)
                                                } else if ((formatBreadcrumb(segment) === 'Mandate by Law' || formatBreadcrumb(segment) === 'Mandate by Board') && (location.pathname.includes('manage-compliance') || location.pathname.includes('compliance-setup'))) {
                                                    routePath = `/${pathnames.slice(0, index).join("/")}`;
                                                }
                                                if (routePath.includes('user-management')) {
                                                    if (segment === 'user-list') {
                                                        navigate(`/${pathnames.slice(0, 4).join("/")}`)
                                                    } else {
                                                        navigate(`/${pathnames.slice(0, 2).join("/")}`)
                                                    }
                                                } else if ((location.pathname.includes('manage-compliance') || location.pathname.includes('compliance-setup')) && index !== 4) {
                                                    params = '?' + params.split('&').filter((param) => manageComplianceParams.includes(param.split('=')[0])).join('&')
                                                    // if (index === 3) {
                                                    //     manageComplianceParams.push('regulationId')
                                                    //     manageComplianceParams.push('regulation')
                                                    //     manageComplianceParams.push('frequency')
                                                    // }
                                                    // params = '?' + params.split('&').filter((param) => manageComplianceParams.includes(param.split('=')[0])).join('&')
                                                    // if (index !== 4) {
                                                    //     if (index)
                                                    //         navigate(routePath + params)
                                                    // }
                                                    if (['Mandate%20by%20Law', 'Mandate%20by%20Board'].includes(segment)) {

                                                        routePath = `/${pathnames.slice(0, index).join("/")}`;
                                                    } else {
                                                        if (index === 3) {
                                                            routePath = `/${pathnames.slice(0, index - 1).join("/")}`;
                                                        } else {
                                                            routePath = `/${pathnames.slice(0, index + 1).join("/")}`;
                                                        }
                                                    }
                                                    navigate(routePath + params)
                                                }
                                            }
                                        }} className={cn(index === lastIndexPath ? "text-primary font-normal" : 'text-border font-normal', 'cursor-pointer')}>
                                            {formatBreadcrumb(segment)}
                                        </div>
                                        {index !== lastIndexPath && <FaChevronRight className='text-primary inline w-[15px] h-[15px] ml-3 mr-3 cursor-pointer' />}
                                    </div>
                                );
                            })}
                        </Stack>
                    </div>
                    {!(location.pathname.includes(risk.URI) ? ((filteredPathnames[filteredPathnames.length - 3]?.includes(risk.URI)
                        && filteredPathnames.length === 3 && RiskChip()
                        && location.pathname.includes(risk.URI)) || (('/' + filteredPathnames[filteredPathnames.length - 3])?.includes(ISSUE.URI)
                            && filteredPathnames.length === 3 && IssueChip()
                            && location.pathname.includes(ISSUE.URI)))
                        : ((filteredPathnames[filteredPathnames.length - 2]?.includes(history.URI) && filteredPathnames.length === 2 && RiskChip() && location.pathname.includes(history.URI)) ||
                            (('/' + filteredPathnames[filteredPathnames.length - 2])?.includes(REJECTED.URI) && filteredPathnames.length === 2 && RiskChip() && location.pathname.includes(REJECTED.URI))
                            || (
                                ('/' + filteredPathnames[filteredPathnames.length - 3])?.includes(ISSUE.URI)
                                && filteredPathnames.length === 3 && IssueChip()
                                && location.pathname.includes(ISSUE.URI)
                            )))
                        && <div className="basis-1/6 flex flex-row justify-end items-center gap-5 mr-4">
                            <Tooltip title="Notification" placement="bottom" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                <div className='pt-2'>
                                    <NotificationBellIcon isNotify={notifications?.some(notification => notification?.isRead === false)} handleClickNotification={handleClickNotification} cursor='pointer' width='30' height='28' />
                                </div>
                            </Tooltip>
                            <Tooltip title="Profile" placement="bottom" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                <div>
                                    <ProfileIcon handleClickProfile={handleClickProfile} />
                                </div>
                            </Tooltip>
                        </div>}


                    <Profile ProfileAnchor={ProfileAnchor} setProfileAnchor={setProfileAnchor} />
                    <Notification notifications={notifications} setNotifications={setNotifications} notificationAnchor={notificationAnchor} setNotificationAnchor={setNotificationAnchor} />
                </div>
            </Card>
        </Fragment>
    );
};

export default Breadcrumbs;
